let Constants = {
	SERVER_PATH: `/api/mobile_apps/1.0/`  // (1)
	// SERVER_PATH: `http://192.168.100.111/api/mobile_apps/1.0/` // (2) when DA started on work computer
	// SERVER_PATH: `https://mobile-apps.hivecompany.ru:4443/api/mobile_apps/1.0/` // (3)
	// SERVER_PATH: `https://mobile-apps-test.hivelogin.ru:6443/api/mobile_apps/1.0/`
};

export default Constants;



// WEBPACK FOOTER //
// ./src/constants.js